import angular from 'angular';
import cmDataService from '../data/cm.data.service';
import ISharedModelService from './ISharedModel.service';

let _cmDataService; // eslint-disable-line no-unused-vars

class cmSharedModelService extends ISharedModelService {
  constructor(
    cmDataService, // eslint-disable-line no-shadow
  ) {
    super('cm');
    _cmDataService = cmDataService;

    console.log('app.services.cmSharedModelService created');
  }
}

cmSharedModelService.$inject = [
  'cmDataService',
];

export default angular.module('app.services.cmSharedModelService', [
  cmDataService,
])
  .service('cmSharedModelService', cmSharedModelService)
  .name;
